var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33319 18.1805C3.83534 18.3327 4.51358 18.3327 5.6665 18.3327H14.3332C15.4861 18.3327 16.1643 18.3327 16.6665 18.1805M3.33319 18.1805C3.22552 18.1479 3.12595 18.1083 3.03153 18.0602C2.56112 17.8205 2.17867 17.4381 1.93899 16.9677C1.6665 16.4329 1.6665 15.7328 1.6665 14.3327V5.66602C1.6665 4.26588 1.6665 3.56582 1.93899 3.03104C2.17867 2.56063 2.56112 2.17818 3.03153 1.9385C3.56631 1.66602 4.26637 1.66602 5.6665 1.66602H14.3332C15.7333 1.66602 16.4334 1.66602 16.9681 1.9385C17.4386 2.17818 17.821 2.56063 18.0607 3.03104C18.3332 3.56582 18.3332 4.26588 18.3332 5.66602V14.3327C18.3332 15.7328 18.3332 16.4329 18.0607 16.9677C17.821 17.4381 17.4386 17.8205 16.9681 18.0602C16.8737 18.1083 16.7742 18.1479 16.6665 18.1805M3.33319 18.1805C3.33346 17.5061 3.33751 17.1492 3.39722 16.849C3.66024 15.5267 4.6939 14.4931 6.0162 14.2301C6.3382 14.166 6.72541 14.166 7.49984 14.166H12.4998C13.2743 14.166 13.6615 14.166 13.9835 14.2301C15.3058 14.4931 16.3394 15.5267 16.6025 16.849C16.6622 17.1492 16.6662 17.5061 16.6665 18.1805M13.3332 7.91602C13.3332 9.75697 11.8408 11.2493 9.99984 11.2493C8.15889 11.2493 6.6665 9.75697 6.6665 7.91602C6.6665 6.07507 8.15889 4.58268 9.99984 4.58268C11.8408 4.58268 13.3332 6.07507 13.3332 7.91602Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSquare);
export default __webpack_public_path__ + "static/media/user-square.a1f2db6f332033d187f1dd8327e7a1bf.svg";
export { ForwardRef as ReactComponent };